import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import DashIcon from "components/icons/DashIcon";
import { MdKeyboardArrowDown, MdKeyboardArrowRight } from "react-icons/md";
import { useAuth } from "context/AuthContext";

export function SidebarLinks(props) {
    let location = useLocation();
    const { routes } = props;
    const { user } = useAuth();
    const [openMenus, setOpenMenus] = useState({});

    // KULLANICI ROLÜ
    const userRole = user?.role || "guest";

    // --- ZIPLAMA HATASININ ÇÖZÜLDÜĞÜ YER ---
    // Sıralamayı (order) URL'den değil, kullanıcının ana ROLÜNDEN alıyoruz!
    // Admin, /vault rotasına gitse bile menü admin sıralamasıyla (order.admin) sabit kalır.
    const sortKey = ["admin", "vault", "staff", "customer"].includes(userRole) ? userRole : "admin";

    // Tam eşleşme ve alt yolları doğru algılayan mermi geçirmez mantık
    const activeRoute = (layout, path) => {
        const fullPath = `${layout}/${path}`;
        return location.pathname === fullPath || location.pathname.startsWith(`${fullPath}/`);
    };

    const createLinks = (routes) => {
        // Sadece yetkimizin olduğu ve sidebar'da görünmesi gerekenleri filtrele ve SABİT SIRALA
        const visibleRoutes = routes
            .filter(route => route.roles?.includes(userRole) && route.sidebarVisible !== false)
            .sort((a, b) => (a.order?.[sortKey] || 99) - (b.order?.[sortKey] || 99));

        const renderedMenus = new Set();
        const elements = [];

        visibleRoutes.forEach((route, index) => {
            // EĞER ROTA BİR DROPDOWN MENÜYE AİTSE
            if (route.menu) {
                if (!renderedMenus.has(route.menu)) {
                    renderedMenus.add(route.menu);

                    // Bu menüye ait tüm rotaları bul
                    const menuItems = visibleRoutes.filter(r => r.menu === route.menu);

                    // Menü açık mı veya içindeki bir rota aktif mi?
                    const isChildActive = menuItems.some(item => activeRoute(item.layout, item.path));
                    const isOpen = openMenus[route.menu] || isChildActive; // Çocuk aktifse otomatik açık başlasın

                    elements.push(
                        <div key={`menu-${index}`} className="flex flex-col">
                            {/* Menü Başlığı */}
                            <div
                                onClick={() => setOpenMenus(prev => ({...prev, [route.menu]: !prev[route.menu]}))}
                                className="relative mb-3 flex cursor-pointer items-center px-8 transition-colors"
                            >
                                <span className={`${isChildActive ? "text-brand-500" : "text-gray-600 dark:text-white"}`}>
                                    {route.menuIcon || <DashIcon />}
                                </span>
                                <p className={`ml-4 flex-1 ${isChildActive ? "font-bold text-navy-700 dark:text-white" : "font-medium text-gray-600 dark:text-gray-300 hover:text-navy-700 dark:hover:text-white"}`}>
                                    {route.menu}
                                </p>
                                {isOpen ? <MdKeyboardArrowDown className="text-gray-600 dark:text-white" /> : <MdKeyboardArrowRight className="text-gray-600 dark:text-white" />}
                            </div>

                            {/* Menü İçeriği (Accordion Animasyonu) */}
                            <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? "max-h-[500px]" : "max-h-0"}`}>
                                <ul className="mb-3 flex flex-col gap-1 pl-16">
                                    {menuItems.map((subItem, subIndex) => {
                                        const isActive = activeRoute(subItem.layout, subItem.path);
                                        return (
                                            <Link key={subIndex} to={subItem.layout + "/" + subItem.path}>
                                                <li className={`flex items-center gap-3 text-sm py-1.5 transition-colors ${isActive ? "font-bold text-brand-500 dark:text-brand-400" : "font-medium text-gray-500 hover:text-navy-700 dark:text-gray-400 dark:hover:text-white"}`}>
                                                    <span className="text-[18px] opacity-70">{subItem.icon || <DashIcon />}</span>
                                                    {subItem.name}
                                                </li>
                                            </Link>
                                        );
                                    })}
                                </ul>
                            </div>
                        </div>
                    );
                }
            } else {
                // EĞER ROTA NORMAL BİR LİNK İSE
                const isActive = activeRoute(route.layout, route.path);
                elements.push(
                    <Link key={`route-${index}`} to={route.layout + "/" + route.path}>
                        <div className="relative mb-3 flex hover:cursor-pointer">
                            <li className="my-[3px] flex cursor-pointer items-center px-8">
                                <span className={`${isActive ? "font-bold text-brand-500 dark:text-brand-400" : "text-gray-600 dark:text-white"}`}>
                                    {route.icon || <DashIcon />}
                                </span>
                                <p className={`ml-4 ${isActive ? "font-bold text-navy-700 dark:text-white" : "font-medium text-gray-600 dark:text-gray-300"}`}>
                                    {route.name}
                                </p>
                            </li>
                            {isActive && <div className="absolute right-0 top-px h-9 w-1 rounded-lg bg-brand-500 dark:bg-brand-400" />}
                        </div>
                    </Link>
                );
            }
        });

        return elements;
    };

    return createLinks(routes);
}

export default SidebarLinks;